export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';


export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';

export const LOGIN_USER_WITH_GOOGLE = 'LOGIN_USER_WITH_GOOGLE';
export const LOGIN_USER_WITH_GOOGLE_COMPLETE = 'LOGIN_USER_WITH_GOOGLE_COMPLETE';

export const REGISTER_WITH_GOOGLE = 'REGISTER_WITH_GOOGLE';
export const REGISTER_WITH_GOOGLE_COMPLETE = 'REGISTER_WITH_GOOGLE_COMPLETE';

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_PASSWORD_COMPLETE = 'REQUEST_RESET_PASSWORD_COMPLETE';

export const LOGOUT = 'LOGOUT';